module.exports = __webpack_public_path__ + "static/media/shallow-focus-of-woman-wearing-red-top.9d92b8d6.jpg";